import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { TableRow } from '@mui/material';
import TableCell from 'src/components/Table/TableCell';
import { getClientFullName } from 'src/utils/common';
import { useTranslation } from 'react-i18next';
import { getContractEventsLabels } from 'src/utils/constants/contracts';
import selectFormatDate from 'src/utils/selectDateFormat';
import { getEventContractStatusIcon } from 'src/utils/contracts';
import OverflowTipography from 'src/components/OverflowTipography';
import { Link } from 'react-router-dom';

const ContractEventsRow = ({ eventType, createdAt, status, client }) => {
  const { t } = useTranslation();
  const clientName = useMemo(() => {
    if (!client) return t('COMMON.NO_DATA');

    return getClientFullName(client);
  }, [client, t]);
  const statusIcon = useMemo(() => getEventContractStatusIcon(status), [
    status
  ]);
  const eventLabels = getContractEventsLabels(t);
  const eventLabel =
    eventLabels.find(label => label.key === eventType)?.name || eventType;

  return (
    <TableRow hover>
      <TableCell align="center">{selectFormatDate(createdAt)}</TableCell>
      <TableCell
        style={{
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis'
        }}
      >
        <OverflowTipography title={clientName}>
          {client ? (
            <Link
              style={{ textDecoration: 'none' }}
              to={`/clients/detail/${client.id}`}
              maxWidth="200px"
            >
              {clientName}
            </Link>
          ) : (
            t('COMMON.NO_DATA')
          )}
        </OverflowTipography>
      </TableCell>

      <TableCell align="center">{statusIcon}</TableCell>
      <TableCell align="center">{eventLabel}</TableCell>
    </TableRow>
  );
};

ContractEventsRow.propTypes = {
  eventType: PropTypes.string,
  createdAt: PropTypes.string,
  status: PropTypes.string,
  client: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    name: PropTypes.string,
    fullName: PropTypes.string,
    personType: PropTypes.string,
    paternalName: PropTypes.string,
    maternalName: PropTypes.string,
    denomination: PropTypes.string
  })
};

export default ContractEventsRow;
